// Generated by ReScript, PLEASE EDIT WITH CARE


function getV2LearnMoreVid(geo_region) {
  switch (geo_region) {
    case /* Bangalore */2 :
        return "https://www.youtube.com/embed/CYuW5_dExHQ?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    case /* Hyderabad */3 :
        return "https://www.youtube.com/embed/Nh8wWL9a2V4?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    case /* Chennai */4 :
    case /* Coimbatore */11 :
        return "https://www.youtube.com/embed/QmbTF7Npw4o?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    case /* Mumbai */0 :
    case /* Delhi */1 :
    case /* Ahmedabad */5 :
    case /* Jaipur */6 :
    case /* Pune */7 :
    case /* Kolkata */8 :
    case /* Surat */9 :
    case /* Lucknow */10 :
    case /* Indore */12 :
    case /* Nagpur */13 :
    case /* Chandigarh */14 :
    case /* Vadodara */15 :
    case /* Ludhiana */16 :
    case /* Kochi */17 :
    case /* Nashik */18 :
    case /* Kanpur */19 :
    case /* Other */20 :
        return "https://www.youtube.com/embed/Ad55fOGoaCY?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    
  }
}

function getV1InfoVid2w(geo_region) {
  if (geo_region !== 2) {
    return "https://www.youtube.com/embed/-yYEN8ajS5M?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
  } else {
    return "https://www.youtube.com/embed/OaXfvd9HhxU?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
  }
}

function getV1InfoVidTrucks(geo_region) {
  if (geo_region >= 12) {
    return "https://www.youtube.com/embed/HTieOC4fXis?si=7eYxtHnh91V5mmiV&autoplay=0&modestbranding=1&fs=0&rel=0";
  }
  switch (geo_region) {
    case /* Bangalore */2 :
        return "https://www.youtube.com/embed/OaXfvd9HhxU?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    case /* Mumbai */0 :
    case /* Delhi */1 :
    case /* Hyderabad */3 :
    case /* Ahmedabad */5 :
    case /* Jaipur */6 :
    case /* Pune */7 :
    case /* Kolkata */8 :
    case /* Surat */9 :
    case /* Lucknow */10 :
        return "https://www.youtube.com/embed/HTieOC4fXis?si=7eYxtHnh91V5mmiV&autoplay=0&modestbranding=1&fs=0&rel=0";
    case /* Chennai */4 :
    case /* Coimbatore */11 :
        return "https://www.youtube.com/embed/Z00L5_hLddA?si=NCF6WMTeR-jo7EaW&autoplay=0&modestbranding=1&fs=0&rel=0";
    
  }
}

export {
  getV2LearnMoreVid ,
  getV1InfoVid2w ,
  getV1InfoVidTrucks ,
  
}
/* No side effect */
